import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ApplicationQueryKeys } from "./keys";
import { IApplication } from "../../models/Application/Application";

export default function useApplication(applicationId: string) {
  const { get } = useApiHelper();

  const application = useQuery({
    queryKey: ApplicationQueryKeys.single(applicationId),
    queryFn: () =>
      get<IDefaultResponse<IApplication>>(`/application/${applicationId}`).then(
        (res) => res.data
      ),
  });

  return {
    application,
  };
}
